import React from 'react';
import {Card} from "react-bootstrap";

const LockedRosterLoad = () => {
    return (
        <Card className={"mb-2"}>
            <Card.Body className={"bg-light"}>
                <Card.Title>This roster load is currently unavailable</Card.Title>
                <Card.Text>This roster load is unavailable until data conversion is complete.</Card.Text>
            </Card.Body>
        </Card>
    )
}
export default LockedRosterLoad